export default "__VITE_ASSET__CRfF$O2U__"